import { schema, types } from 'papr'

export const publicationMemberSchema = schema(
	{
		publication: types.objectId({ required: true }),
		user: types.objectId({ required: true }),
		role: types.enum(['admin' as const, 'contributor' as const, 'author' as const], {
			required: true,
		}),
		username: types.string(),
		memberPhoto: types.string(),
		memberName: types.string(),
		privacyState: types.enum(['private' as const, 'public' as const]),
	},
	{
		timestamps: true,
		defaults: {
			role: 'contributor' as const,
			privacyState: 'public' as const,
		},
	},
)

export type PublicationMemberDocument = (typeof publicationMemberSchema)[0]
export type PublicationMemberSchemaOptions = (typeof publicationMemberSchema)[1]
